import { useContext, useState } from 'react';
import * as R from 'ramda';

import { TYPE_LABELS } from '@atom/components/common/requests/assetRequestConstants';
import { Button, Icon } from '@atom/mui';
import colors from '@atom/styles/colors';
import { AssetRequestStatus } from '@atom/types/assetRequest';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';

import ViewRequestContext from '../ViewRequestContext';

import AddReplenishmentView from './AddReplenishmentView';
import EditReplenishmentView from './EditReplenishmentView';
import ReplenishmentView from './ReplenishmentView';

import classes from './sddotView.module.css';

const SDDOTReplenishmentView = () => {
  const { activeRequest } = useContext(ViewRequestContext);

  const [createView, setCreateView] = useState<boolean>(false);
  const [editId, setEditId] = useState<string>();

  const totalQuantityReceived = activeRequest?.replenishments?.reduce(
    (acc, replenishment) => {
      return acc + Number(replenishment.quantityReceived || 0);
    },
    0,
  );

  const totalQuantityRemaining =
    R.pathOr(0, ['quantityOrdered'], activeRequest) - totalQuantityReceived;

  const showCreateButton =
    hasRolePermissions(ROLE_SETS.INSPECTOR) &&
    activeRequest?.status !== AssetRequestStatus.FULLY_RECEIVED;

  return (
    <div>
      <div className={classes.viewRow}>
        <div className={classes.rowTitle}>Request Type</div>
        <div>{TYPE_LABELS[activeRequest?.type]}</div>
      </div>
      <div className={classes.viewRow}>
        <div className={classes.rowTitle}>Inventory Name</div>
        <div>{activeRequest?.assetName}</div>
      </div>
      <div className={classes.replenishmentRow}>
        <div>
          <div className={classes.rowTitle}>{`Total Quantity Ordered (${
            activeRequest?.assetUnit || ''
          })`}</div>
          <div>{activeRequest?.quantityOrdered}</div>
        </div>
        <div>
          <div className={classes.rowTitle}>{`Total Quantity Received (${
            activeRequest?.assetUnit || ''
          })`}</div>
          <div>{totalQuantityReceived}</div>
        </div>
        <div>
          <div
            className={classes.rowTitle}
          >{`Total Remaining Quantity on Order (${
            activeRequest?.assetUnit || ''
          })`}</div>
          <div>{totalQuantityRemaining}</div>
        </div>
      </div>
      <div className={classes.viewRow}>
        {activeRequest?.replenishments.map(replenishment => {
          return replenishment?.id === editId ? (
            <EditReplenishmentView
              key={replenishment.id}
              replenishment={replenishment}
              onCancel={() => setEditId(null)}
            />
          ) : (
            <ReplenishmentView
              key={replenishment.id}
              replenishment={replenishment}
              editId={editId}
              setEditId={setEditId}
            />
          );
        })}
      </div>
      {createView ? (
        <AddReplenishmentView onCancel={() => setCreateView(false)} />
      ) : showCreateButton ? (
        <Button
          variant="contained"
          color="primary"
          startIcon={<Icon color={colors.neutral.white}>add</Icon>}
          onClick={() => setCreateView(true)}
        >
          Create Replenishment
        </Button>
      ) : (
        <div />
      )}
    </div>
  );
};

export default SDDOTReplenishmentView;
